export const translations = {
    en: {
        dir: 'ltr',
        home: 'Home',
        about: 'About Us',
        projects: 'Projects',
        gallery: 'Gallery',
        tech: 'Innovation',
        contact: 'Contact Us',
        crane: 'Crane Services',
        acoustics: 'Acoustics Guide',
        hero: 'Advanced Aluminum Systems',
        send: 'Submit Request',
        name: 'Full Name',
        email: 'Email Address',
        msg: 'How can we help you?',

        // About Us Page
        aboutTitle: "Four Decades of Excellence",
        aboutText: "With over 40 years of experience, Alum Nawatha LTD has established itself as a leader in precision aluminum manufacturing. Founded in 1986 on principles of integrity and superior craftsmanship, we specialize in high-end architectural solutions, custom windows, and innovative facade systems. We combine traditional expertise with cutting-edge technology to serve the most demanding residential and commercial projects.",
        experience: "40+ Years of Experience",
        foundedLabel: "Established",
        precisionLabel: "Precision",

        // Gallery Page
        gallerySubtitle: "A visual journey through 40 years of architectural precision.",

        // Floating Call Button
        callNow: "Call Now",
        phone: "+972-52-878-4031" // Replace with your actual phone number
    },
    he: {
        dir: 'rtl',
        home: 'דף הבית',
        about: 'אודותינו',
        projects: 'פרויקטים',
        gallery: 'גלריה',
        tech: 'חדשנות',
        contact: 'צור קשר',
        crane: 'שירותי מנוף',
        acoustics: 'מדריך אקוסטיקה',
        hero: 'מערכות אלומיניום מתקדמות',
        send: 'שלח בקשה',
        name: 'שם מלא',
        email: 'כתובת אימייל',
        msg: 'איך נוכל לעזור?',

        // About Us Page
        aboutTitle: "ארבעה עשורים של מצוינות",
        aboutText: "עם מעל 40 שנות ניסיון, חברת אלום נואטחה בע״מ ביססה את עצמה כמובילה בייצור אלומיניום מדויק. החברה הוקמה בשנת 1986 על עקרונות של יושרה ומקצועיות ללא פשרות, ואנו מתמחים בפתרונות אדריכליים יוקרתיים, חלונות בעיצוב אישי ומערכות חיפוי חדשניות. אנו משלבים מומחיות מסורתית עם טכנולוגיה מתקדמת עבור הפרויקטים התובעניים ביותר.",
        experience: "מעל 40 שנות ניסיון",
        foundedLabel: "נוסדה בשנת",
        precisionLabel: "דיוק ואיכות",

        // Gallery Page
        gallerySubtitle: "מסע חזותי דרך 40 שנות דיוק אדריכלי.",

        // Floating Call Button
        callNow: "התקשר עכשיו",
        phone: "+972-52-878-4031" // Replace with your actual phone number
    },
    ar: {
        dir: 'rtl',
        home: 'الرئيسية',
        about: 'من نحن',
        projects: 'المشاريع',
        gallery: 'المعرض',
        tech: 'ابتكار',
        contact: 'اتصل بنا',
        crane: 'خدمات الرافعة',
        acoustics: 'دليل الصوتيات',
        hero: 'أنظمة الألمنيوم المتقدمة',
        send: 'إرسال الطلب',
        name: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        msg: 'كيف يمكننا مساعدتك؟',

        // About Us Page
        aboutTitle: "أربعة عقود من التميز",
        aboutText: "مع أكثر من 40 عامًا من الخبرة، أثبتت شركة ألمنيوم نواثه م.ض نفسها كشركة رائدة في تصنيع الألمنيوم الدقيق. تأسست الشركة عام 1986 على مبادئ النزاهة والحرفية العالية، ونحن متخصصون في الحلول المعمارية الراقية، والنوافذ المخصصة، وأنظمة الواجهات المبتكرة. نجمع بين الخبرة التقليدية وأحدث التقنيات لخدمة المشاريع السكنية والتجارية الأكثر تطلبًا.",
        experience: "أكثر من 40 عاماً من الخبرة",
        foundedLabel: "تأسست عام",
        precisionLabel: "دقة وإتقان",

        // Gallery Page
        gallerySubtitle: "رحلة بصرية عبر 40 عاماً من الدقة المعمارية.",

        // Floating Call Button
        callNow: "اتصل الآن",
        phone: "+972-52-878-4031" // Replace with your actual phone number
    }
};